<template>
  <div :class="['ActionButton', {'ActionButton--dark': dark}]"
    @mouseenter="onMouseOver"
    @mouseleave="onMouseOut"
    @click="$emit('click', $event.target.value)"
  >
  <div class="container" ref="container">
    <div class="wrapper" ref="wrapper">
      <div class="mask" ref="mask">
        <div class="ActionButton-btn front" ref="btn">
            <slot></slot>
        </div>
        <div class="ActionButton-shadow shadowF" ref="shadowf"></div>
        <div class="move" ref="move">
          <div class="ActionButton-btn back">
            <slot></slot>
          </div>
          <div class="ActionButton-shadow shadowB" ref="shadowb"></div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { TimelineMax, Expo } from 'gsap'

export default {
  props: {
    dark: Boolean,
    width: Number
  },
  data () {
    return {
      tlIn: null,
      tlOut: null,
      height: 0,
      value: 0,
      _direction: null,
      reset: false
    }
  },
  mounted () {
    this.setSizes()
  },
  methods: {
    setSizes () {
      if (this.$device.isMobile) return
      this.height = (this.$refs.btn.offsetHeight || 71)

      this.$refs.container.style.width = this.width + 'px'
      this.$refs.container.style.height = this.height + 'px'
      this.$refs.wrapper.style.width = this.width + 'px'
      this.$refs.wrapper.style.height = this.height + 'px'
      this.$refs.move.style.width = this.width + 'px'
      this.$refs.move.style.height = this.height + 'px'
      this.$refs.shadowf.style.width = this.width + 'px'
      this.$refs.shadowf.style.height = this.height + 'px'
    },
    checkDirection (e, pos, sizeQ) {
      const fx = pos.x
      const fy = pos.y
      const tx = e.pageX - fx
      const ty = e.pageY - fy
      let direction
      if (tx < sizeQ) direction = 0 // left
      else if (tx > sizeQ * 3) direction = 1 // right
      else if (ty < sizeQ) direction = 2 // top
      else direction = 3 // bottom
      return direction
    },
    _getDir (coordinates) {
    // the width and height of the current div
      const w = this.$el.offsetWidth
      const h = this.$el.offsetHeight
      const offset = this.$el.getBoundingClientRect()

      // calculate the x and y to get an angle to the center of the div from that x and y.
      // gets the x value relative to the center of the DIV and "normalize" it
      const x = (coordinates.x - offset.left - (w / 2)) * (w > h ? (h / w) : 1)
      const y = (coordinates.y - offset.top - (h / 2)) * (h > w ? (w / h) : 1)

      // the angle and the direction from where the mouse came in/went out clockwise (TRBL=0123);
      // first calculate the angle of the point,
      // add 180 deg to get rid of the negative values
      // divide by 90 to get the quadrant
      // add 3 and do a modulo by 4 to shift the quadrants to a proper clockwise TRBL (top/right/bottom/left) **/
      const direction = Math.round((((Math.atan2(y, x) * (180 / Math.PI)) + 180) / 90) + 3) % 4
      return direction
    },
    applyDirClasses ($el, dir) {
      $el.classList.remove('dir--0')
      $el.classList.remove('dir--1')
      $el.classList.remove('dir--2')
      $el.classList.remove('dir--3')
      $el.classList.add('dir--' + dir)
    },
    onMouseOver (e) {
      if (this.$device.isMobile) return
      if (!this.reset) {
        this.setSizes()
        this.reset = true
      }
      this._direction = this._getDir({ x: e.pageX, y: e.pageY })

      this.applyDirClasses(this.$el, this._direction)
      const w = this.width
      const h = this.height

      if (this.tlOut) this.tlOut.kill()
      this.tlIn = new TimelineMax()

      const coef = 0.2
      const coefY = 0.3
      const d = 0.8

      // console.log('iii>', this.width * coef, -10 * coef)
      // from right
      if (this._direction === 1) {
        this.tlIn.fromTo(this.$refs.move, d, { x: 0, y: 0 }, { x: -w * coef, ease: Expo.easeOut }, 0)
        // this.tlIn.fromTo(this.$refs.move, d, { xPercent: 0, y: 0 }, { xPercent: -10 * coef, ease: Expo.easeOut }, 0)
        this.tlIn.fromTo(this.$refs.shadowf, d, { yPercent: 0, xPercent: 0, scaleX: 0, scaleY: 1 }, { scaleX: 0.5, xPercent: -100, ease: Expo.easeOut }, 0)
        this.tlIn.fromTo(this.$refs.shadowb, d, { y: 0, x: w * coef, scaleX: 0 }, { x: 0, scaleX: 1, ease: Expo.easeOut }, 0)
        this.tlIn.fromTo(this, d, { value: 0 }, {
          value: coef,
          ease: Expo.easeOut,
          onUpdate: () => {
            this.$refs.wrapper.style.width = w * (1 - this.value) + 'px'
            // this.$refs.shadowb.style.width = w * (1 - this.value) + 'px'
            // this.$refs.shadowf.style.width = w * (this.value) + 'px'
          }
        }, 0)

        this.tlIn.to(this.$refs.move, 0.6, { x: 0, xPercent: 0, y: 0, ease: Expo.easeOut }, d)
        this.tlIn.to(this.$refs.shadowf, 0.6, { yPercent: 0, xPercent: 0, scale: 1, ease: Expo.easeOut }, d)
        // this.tlIn.to(this.$refs.shadowb, 0.6, { y: 0, x: w * coef, ease: Expo.easeOut }, 0)
        this.tlIn.fromTo(this.$refs.shadowb, d, { y: 0, x: w * coef }, { x: 0, ease: Expo.easeOut }, 0)

        this.tlIn.to(this, 0.6, {
          value: 0,
          ease: Expo.easeOut,
          onUpdate: () => {
            // console.log(w * (1 - v.var))
            this.$refs.wrapper.style.width = this.width * (1 - this.value) + 'px'
          }
        }, d)
      }

      // from top
      if (this._direction === 0) {
        this.tlIn.fromTo(this.$refs.move, d, { x: 0, y: 0, z: 0 }, { y: h * coefY, ease: Expo.easeOut }, 0)
        this.tlIn.fromTo(this.$refs.shadowf, d, { xPercent: 0, yPercent: 0, scaleX: 1, scaleY: 0, z: 0 }, { scaleY: 0.5, ease: Expo.easeOut }, 0)
        this.tlIn.fromTo(this.$refs.shadowb, d, { x: 0, y: h * coefY }, { x: 0, y: 0, ease: Expo.easeOut }, 0)
        this.tlIn.fromTo(this, d, { value: 0 }, {
          value: coefY,
          ease: Expo.easeOut,
          onUpdate: () => {
            this.$refs.wrapper.style.height = h * (1 - this.value) + 'px'
          }
        }, 0)

        this.tlIn.to(this.$refs.move, d, { xPercent: 0, yPercent: 0, x: 0, y: 0, z: 0, ease: Expo.easeOut }, d)
        this.tlIn.to(this.$refs.shadowf, d, { xPercent: 0, yPercent: 0, scaleX: 1, scaleY: 0, ease: Expo.easeOut }, d)
        this.tlIn.to(this.$refs.shadowb, d, { x: 0, y: h * coefY, ease: Expo.easeOut }, d)
        this.tlIn.to(this, d, {
          value: 0,
          ease: Expo.easeOut,
          onUpdate: () => {
            this.$refs.wrapper.style.height = h * (1 - this.value) + 'px'
          }
        }, d)
      }

      // from bottom
      if (this._direction === 2) {
        this.tlIn.fromTo(this.$refs.move, d, { x: 0, y: 0, z: 0 }, { y: -h * coefY, ease: Expo.easeOut }, 0)
        this.tlIn.fromTo(this.$refs.shadowf, d, { xPercent: 0, yPercent: 0, scaleX: 1, scaleY: 0, z: 0 }, { scaleY: 0.5, ease: Expo.easeOut }, 0)
        this.tlIn.fromTo(this.$refs.shadowb, d, { x: 0, y: h * coefY }, { x: 0, y: 0, ease: Expo.easeOut }, 0)
        this.tlIn.fromTo(this, d, { value: 0 }, {
          value: coefY,
          ease: Expo.easeOut,
          onUpdate: () => {
            this.$refs.wrapper.style.height = h * (1 - this.value) + 'px'
          }
        }, 0)

        this.tlIn.to(this.$refs.move, d, { xPercent: 0, yPercent: 0, x: 0, y: 0, z: 0, ease: Expo.easeOut }, d)
        this.tlIn.to(this.$refs.shadowf, d, { xPercent: 0, yPercent: 0, scaleX: 1, scaleY: 0, ease: Expo.easeOut }, d)
        this.tlIn.to(this.$refs.shadowb, d, { x: 0, y: h * coefY, ease: Expo.easeOut }, d)
        this.tlIn.to(this, d, {
          value: 0,
          ease: Expo.easeOut,
          onUpdate: () => {
            this.$refs.wrapper.style.height = h * (1 - this.value) + 'px'
          }
        }, d)
      }
      // from left
      if (this._direction === 3) {
        this.tlIn.fromTo(this.$refs.move, d, { xPercent: 0, y: 0 }, { xPercent: 10 * coef, ease: Expo.easeOut }, 0)
        this.tlIn.fromTo(this.$refs.shadowf, d, { xPercent: -100, yPercent: 0, scaleY: 1, scaleX: 0, z: 0 }, { xPercent: 0, scaleX: 0.5, ease: Expo.easeOut }, 0)
        this.tlIn.fromTo(this, d, { value: 0 }, {
          value: coef,
          ease: Expo.easeOut,
          onUpdate: () => {
            this.$refs.wrapper.style.width = this.width * (1 - this.value) + 'px'
          }
        }, 0)

        this.tlIn.to(this.$refs.move, 0.6, { x: 0, xPercent: 0, y: 0, ease: Expo.easeOut }, d)
        this.tlIn.to(this.$refs.shadowf, 0.6, { yPercent: 0, xPercent: -100, scale: 1, ease: Expo.easeOut }, d)
        this.tlIn.fromTo(this.$refs.shadowb, d, { y: 0, x: w * coef }, { x: 0, ease: Expo.easeOut }, 0)

        this.tlIn.to(this, 0.6, {
          value: 0,
          ease: Expo.easeOut,
          onUpdate: () => {
            // console.log(w * (1 - v.var))
            this.$refs.wrapper.style.width = this.width * (1 - this.value) + 'px'
          }
        }, d)
      }

      // this.tlIn.fromTo(this.$el, d, { scale: 1 }, { scale: 1.04, ease: Expo.easeOut }, d + 0.2)
    },
    onMouseOut () {
      if (this.$device.isMobile) return
      // console.log('out')
      if (this.tlIn) this.tlIn.kill()
      this.tlOut = new TimelineMax()
      const coefY = 0.3
      const coef = 0.2
      // from right or from left
      if (this._direction === 1 || this._direction === 3) {
        this.tlOut.to(this.$refs.move, 0.6, { x: 0, y: 0, xPercent: 0, yPercent: 0, ease: Expo.easeOut }, 0)
        if (this._direction === 1)
          this.tlOut.to(this.$refs.shadowf, 0.6, { yPercent: 0, xPercent: 0, scaleY: 1, scaleX: 1, ease: Expo.easeOut }, 0)
        if (this._direction === 3)
          this.tlOut.to(this.$refs.shadowf, 0.6, { yPercent: 0, xPercent: -100, scaleY: 1, scaleX: 1, ease: Expo.easeOut }, 0)
        this.tlOut.to(this.$refs.shadowb, 0.6, { y: 0, x: this.width, ease: Expo.easeOut }, 0)

        // this.tlOut.to(this.$refs.shadowf, 0.6, { x: this.width * 0.8, ease: Expo.easeOut }, 0)
        this.tlOut.to(this, 0.6, {
          value: 0,
          ease: Expo.easeOut,
          onUpdate: () => {
            // console.log(w * (1 - v.var))
            this.$refs.wrapper.style.width = this.width * (1 - this.value) + 'px'
          }
        }, 0)
      }

      // from top
      if (this._direction === 0 || this._direction === 2) {
        this.tlOut.to(this.$refs.move, 0.6, { x: 0, y: 0, z: 0, ease: Expo.easeOut }, 0)
        this.tlOut.to(this.$refs.shadowf, 0.6, { xPercent: 0, yPercent: 0, scaleX: 1, scaleY: 0, ease: Expo.easeOut }, 0)
        this.tlOut.to(this.$refs.shadowb, 0.6, { x: 0, y: this.height * coefY, ease: Expo.easeOut }, 0)
        this.tlOut.to(this, 0.6, {
          value: 0,
          ease: Expo.easeOut,
          onUpdate: () => {
            this.$refs.wrapper.style.height = this.height * (1 - this.value) + 'px'
          }
        }, 0)
      }
      // this.tlOut.to(this.$el, 0.4, { scale: 1, ease: Expo.easeOut }, 0.6)

      this._direction = null
    }
  }
}
</script>

<style lang="stylus">
  .ActionButton
    // position absolute
    // bottom 4%
    // right 4%
    margin auto
    z-index 100
    cursor pointer
    backface-visibility hidden
    white-space nowrap
    .container
      position relative
      overflow hidden
      border-radius 40px
      backface-visibility hidden
    .wrapper
      overflow hidden
      position absolute
      top 0
      left 0
      // background yellow
      backface-visibility hidden
    &-btn
      padding 20px 50px 20px 50px
      font-size 1.2rem
      font-family 'LeagueMonoBold'
      border-radius 40px
      border 0
      color black
      background white
      text-transform uppercase
      position absolute
      backface-visibility hidden
      border 1px solid white
      transition background 100ms linear
      display flex
      span
      svg
        align-self center
      // position relative // DANGER
      svg
        position relative
        // left 40px
        top 4px
        left -4px
        stroke black
        height 29px
        margin-right 9px
    &-shadow
      position absolute
      width 100%
      height 100%
      left 0px
      top 0px
      z-index 1
      // border-radius 40px
    .shadowB
      left 0
      background linear-gradient(to right, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 10%, rgba(0,0,0,0.1) 18%, rgba(0,0,0,0.7) 100%)
    .shadowF
      background linear-gradient(to right, rgba(0,0,0,0) 0%,rgba(0,0,0,0.01) 40%,rgba(0,0,0,0.7) 100%)
      left 100%
      transform-origin 100% 0

    // .shadowB
    //   background linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.01) 1%,rgba(0,0,0,0.7) 100%)
    // .shadowT
    //   background linear-gradient(to top, rgba(0,0,0,0) 0%,rgba(0,0,0,0.01) 1%,rgba(0,0,0,0.7) 100%)

    .mask
      // background blue
      border-radius 40px
      overflow hidden
      width 100%
      height 100%
      backface-visibility hidden
    .move
      position absolute
      top 0
      left 100%
      border-radius 40px
      overflow hidden
      z-index 5
      backface-visibility hidden
      .ActionButton-btn
        background red
        color white
        transform scale(-1, 1)
        svg
          fill white
          stroke white
        // opacity 0.5

  .ActionButton.dir--0
    .ActionButton-btn
      top auto
      bottom 0
    .shadowB
      left 0
      background linear-gradient(to top, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 10%, rgba(0,0,0,0.1) 18%, rgba(0,0,0,0.7) 100%)
    .shadowF
      background linear-gradient(to top, rgba(0,0,0,0) 0%,rgba(0,0,0,0.01) 40%,rgba(0,0,0,0.7) 100%)
      left 0
      top 0%
      transform-origin 0% 0
    .move
      top auto
      bottom 100%
      left 0
      transform-origin 0 0
    .wrapper
      top auto
      bottom 0

// from bottom
  .ActionButton.dir--2
    .ActionButton-btn
      top 0
      bottom auto
    .shadowB
      left 0
      bottom 0
      background linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 10%, rgba(0,0,0,0.1) 18%, rgba(0,0,0,0.7) 100%)
    .shadowF
      background linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.01) 40%,rgba(0,0,0,0.7) 100%)
      left 0
      top auto
      bottom 0%
      transform-origin 0% 100%
    .move
      top 100%
      bottom auto
      left 0
      transform-origin 0 0
    .wrapper
      top 0
      bottom auto

  .ActionButton.dir--3
    .ActionButton-btn
      top 0
      bottom auto
      left auto
      right 0
    .move
      top 0
      bottom auto
      left -100%
    .wrapper
      top 0
      right 0
      bottom auto
      left auto
    .shadowB
      left 0
      background linear-gradient(to left, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 10%, rgba(0,0,0,0.1) 18%, rgba(0,0,0,0.7) 100%)
    .shadowF
      background linear-gradient(to left, rgba(0,0,0,0) 0%,rgba(0,0,0,0.01) 40%,rgba(0,0,0,0.7) 100%)
      left 0
      transform-origin 0 0

.ActionButton--dark
  .ActionButton-btn
    color white
    background #1b1b1b
    svg
      fill white
      stroke white

.ActionButton:hover
  .ActionButton-btn.front
    color red
    svg
      fill red
      stroke red

.ActionButton--dark:hover
  .ActionButton-btn.front
    color red
    background white
    border 1px solid red
    svg
      fill red
      stroke red

@media(max-width: 600px)
  .ActionButton
    &-btn
      padding 10px 20px 10px 20px
      font-size 0.9rem
      position relative
      svg
        left 0px
        top 2px
        margin-right 5px
    .wrapper
      position relative

@media(max-width: 320px)
  .ActionButton
    &-btn
      padding 8px 12px
      font-size 0.8rem
</style>
